export default "__VITE_ASSET__DaSfcn2D__"